export const CHANGE_THEME = 'USER_INTERFACE.CHANGE_THEME';
